import {IDENTIFICATION_RESPONSE} from '../actions/identification.actions';

export default function identification(state = {}, action) {
  switch (action.type) {
    case IDENTIFICATION_RESPONSE: {
      let nextState = action.result;
      return nextState;
    }
  }
  return state;
}
